import { http } from '@/api/client/httpClient';
import type {
  BrokerSelectItem,
  ConnectorWarning,
  DataSourceSwapsDto,
  PaginatedOutput,
  SwapsScannerExportInput,
  SwapsScannerExportResult,
  SwapsScannerInternalSwapDto,
  SwapsScannerInternalSwapInput,
  SwapsScannerRawTabDto,
  SwapsScannerRawTabInput,
  SwapsScannerSummaryTabDto,
  SwapsScannerSummaryTabInput,
} from '@/api/types/swapsScanner';

const BASE = '/api/app/swaps-scanner-tabs';

export const swapsScannerApi = {
  getInternalSwap: (input: SwapsScannerInternalSwapInput) =>
    http.get<PaginatedOutput<SwapsScannerInternalSwapDto>>(`${BASE}/internal-swap-for-data-table`, { params: input }).then((r) => r.data),
  getSummaryTab: (input: SwapsScannerSummaryTabInput) =>
    http.get<PaginatedOutput<SwapsScannerSummaryTabDto>>(`${BASE}/summary-tab-for-data-table`, { params: input }).then((r) => r.data),
  getRawTab: (input: SwapsScannerRawTabInput) =>
    http.get<PaginatedOutput<SwapsScannerRawTabDto>>(`${BASE}/raw-tab-for-data-table`, { params: input, paramsSerializer: { indexes: null } }).then((r) => r.data),
  getConnectorWarning: (referenceDate: string) =>
    http.get<ConnectorWarning>(`${BASE}/connector-warning`, { params: { referenceDate } }).then((r) => r.data),
  getMonitorPercentage: () => http.get<number>(`${BASE}/monitor-percentage`).then((r) => r.data),
  getPaginatedBrokers: (search: string, skipCount: number, maxResultCount: number) =>
    http.get<PaginatedOutput<BrokerSelectItem>>(`${BASE}/paginated-brokers-for-select`, { params: { search, skipCount, maxResultCount } }).then((r) => r.data),
  getDataSources: (referenceDate: string) =>
    http.get<DataSourceSwapsDto[]>(`${BASE}/data-sources-for-datatable`, { params: { referenceDate } }).then((r) => r.data),
  requestExcelExport: (input: SwapsScannerExportInput) =>
    http.post<SwapsScannerExportResult>(`${BASE}/request-excel-export`, input).then((r) => r.data),
};
